<template>
  <div class="auto-height invoice-items">
    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
        <tr>
          <th width="200">CONTACT NAME</th>
          <th>POSITION</th>
          <th>PHONE</th>
          <th>EMAIL</th>
          <th width="250">NOTES</th>
          <th width="40"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in client.members" :key="index">
          <td><a href="javascript:;" class="black" @click="editContact( index )">{{ item.full_name }}</a></td>
          <td>{{ item.role }}</td>
          <td>{{ item.phone }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.note}}</td>
          <td align="right">
            <a href="javascript:;" class="icon-pencil mr-2" v-tooltip="'Edit contact'" @click="editContact(index)"></a>
            <a href="javascript:;" class="icon-trash" v-tooltip="'Remove contact'" @click="confDelete(index)"></a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="text-center">
      <button type="button" class="btn btn-outline-black w180" @click="editContact(-1)">Add Contact</button>
    </div>

    <modal-add-contact v-model="showModalEdit" :clientId="client.id" :member="activeItem" @contact-saved="onItemSaved"></modal-add-contact>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import ServiceClient from '@/services/client'
  import ModalAddContact from './ModalAddContact';

  export default {
    components: {
      ModalAddContact,
    },
    data() {
      return {
        showModalEdit: false,
        activeIndex: -1
      }
    },
    computed: mapState({
      client: state => state.client.client,
      activeItem () {
        return this.client.members[this.activeIndex] ? this.client.members[this.activeIndex] : null;
      }
    }),
    created() {},
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.showModalEdit = false;
      },
      editContact ( index ) {
        let self = this;
        self.activeIndex = index;
        self.showModalEdit = true;
      },
      onItemSaved ( item ) {
        let self = this;
        if(self.activeIndex != -1)
          self.client.members.splice( self.activeIndex, 1, item );
        else
          self.client.members.push( item );
      },
      confDelete ( index ) {
        let self = this, item = self.client.members[index];
        self.$dialog
          .confirm('Are you sure you want to delete contact <strong>' + item.full_name + '</strong>?', {
            html: true,
            loader: true,
            okText: "Yes, I'm sure",
            cancelText: "Cancel",
          })
          .then(dialog => {
            ServiceClient.deleteMember(self.client.id, item.id, (data) => {
              dialog.close();
              if(data.status == 'FAILED'){
                self.$notify({
                  type: 'error',
                  text: data.error
                });
              }else {
                self.client.members.splice(index, 1);
                self.$notify({
                  type: 'success',
                  text: 'Contact <strong>' + item.full_name + '</strong> has been deleted'
                });
              }
            });
          })
          .catch(() => {})
        ;
      }
    }
  }
</script>
